import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Field, reduxForm, reset } from 'redux-form';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  passwordExtraMatches,
  required,
  renderField,
  passwordsMustMatch,
} from '../../common/helpers/form-validations';
import SuccessPopUp from '../../common/SuccessPopUp';
import { changePassword } from '../../Services/Utils/UserApis';
import { userLogout } from '../../Services/config/globals';
import { notifySet } from '../../Services/Actions/CommonActions';

function ChangePassword(props) {
  const [type, setType] = useState('password');
  const [showPassword, setShowPassword] = useState(true);
  const [type1, setType1] = useState('password');
  const [showPassword1, setShowPassword1] = useState(true);
  const [type2, setType2] = useState('password');
  const [showPassword2, setShowPassword2] = useState(true);
  const [open, setOpen] = useState(false);

  const handleType = () => {
    if (type === 'text') {
      setType('password');
      setShowPassword(true);
    } else {
      setType('text');
      setShowPassword(false);
    }
  };

  const handleType1 = () => {
    if (type1 === 'text') {
      setType1('password');
      setShowPassword1(true);
    } else {
      setType1('text');
      setShowPassword1(false);
    }
  };

  const handleType2 = () => {
    if (type2 === 'text') {
      setType2('password');
      setShowPassword2(true);
    } else {
      setType2('text');
      setShowPassword2(false);
    }
  };

  // success pop up
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSuccessPopup = (value) => {
    setOpen(value);
    if (value === false) {
      userLogout();
      navigate('/login');
    }
  };

  const onSubmit = (formData) => {
    const newPasswordData = {
      password: formData.oldpassword,
      newPassword: formData.password,
      confirmPassword: formData.confirmpassword
    };
    changePassword(newPasswordData).then(async (response) => {
      const { hasError, message } = response;
      if (hasError === false) {
        dispatch(reset('change-password'));
        handleClickOpen();
      } else {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  const {
    handleSubmit,
    invalid,
    submitting,
    pristine
  } = props;
  return (
    <div className="change-pass-con">
      <div className="row">
        <div className="col-sm-12">
          <h6>Change Password</h6>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
          <div className="banner-cap-left banner-top banner-top-sm">
            <img alt="" src="/assets/images/confirm-password-banner.gif" />
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
          <div className="banner-cap-right caption-block title-bg-text">
            <div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="old-password">
                        Old Password <span className="validation-icon">*</span>
                      </label>
                      <div className="password-icon-fixd">
                        <Field
                          type={type}
                          component={renderField}
                          id="old-password"
                          name="oldpassword"
                          className="form-control"
                          placeholder="Enter password"
                          validate={[required, passwordExtraMatches]}
                        />
                        <div className="password-icon" onClick={handleType}>
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </div>
                        <div className="password-icon">&nbsp;</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="new-password">
                        New Password
                        <span className="validation-icon">*</span>
                      </label>
                      <div className="password-icon-fixd">
                        <Field
                          type={type1}
                          component={renderField}
                          id="new-password"
                          name="password"
                          className="form-control"
                          placeholder="Enter password"
                          validate={[required, passwordExtraMatches]}
                        />
                        <div className="password-icon" onClick={handleType1}>
                          {showPassword1 ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </div>
                        <div className="password-icon">&nbsp;</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="confirm-password">
                        Confirm Password
                        <span className="validation-icon">*</span>
                      </label>
                      <div className="password-icon-fixd">
                        <Field
                          type={type2}
                          component={renderField}
                          id="confirm-password"
                          name="confirmpassword"
                          className="form-control"
                          placeholder="Enter password"
                          validate={[passwordsMustMatch]}
                        />
                        <div className="password-icon" onClick={handleType2}>
                          {showPassword2 ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <div className="btn-con xs-full-btn mt-1">
                        <span>
                          <Button
                            type="submit"
                            className="btn btn-red btn-md"
                            variant="contained"
                            disabled={invalid || pristine || submitting}
                          >
                            Change Password
                          </Button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <SuccessPopUp
        handleClickOpen={handleClickOpen}
        handleSuccessPopup={handleSuccessPopup}
        open={open}
        successMessage="You have successfully changed your password"
      />
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'change-password',
});

export default withForm(ChangePassword);
